var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalLoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FDB426"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_328_2168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2965 45.3684C24.967 45.7576 24.5008 45.2951 24.6287 44.7564L27.0525 34.5616C27.2438 33.7959 26.9446 32.9915 26.2996 32.5369L20.938 29.0219C20.6473 28.7763 20.6077 28.3427 20.8493 28.0486L32.7745 14.6213C33.1103 14.242 33.5852 14.7324 33.4238 15.2798L30.4966 25.2022C30.2492 25.991 30.541 26.8491 31.2179 27.3237L36.5794 30.8685C36.8655 31.1103 36.9083 31.5353 36.6762 31.8293L25.2965 45.3684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2759 38.0685C44.2759 39.0969 43.4422 39.9306 42.4138 39.9306H31.4897L37.6302 32.6257C37.9806 32.2006 38.1328 31.6462 38.0486 31.1019C37.9813 30.5862 37.6972 30.1238 37.2677 29.8307L31.9037 26.2884C31.6889 26.1102 31.6041 25.8192 31.6896 25.5535L33.3058 20.0685H42.4138C43.4422 20.0685 44.2759 20.9022 44.2759 21.9306V38.0685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0001 33.1029C48.0001 33.4457 47.7222 33.7237 47.3793 33.7237H45.5173V26.2754H47.3794C47.7222 26.2754 48.0001 26.5533 48.0001 26.8961L48.0001 33.1029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5007 39.9306L24.2028 41.172H20.069C19.7262 41.172 19.4482 40.8941 19.4482 40.5513C19.4482 40.2084 19.7261 39.9305 20.069 39.9305H24.5007V39.9306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5862 41.172H15.7242C15.3815 41.172 15.1035 40.8941 15.1035 40.5513C15.1035 40.2084 15.3814 39.9305 15.7242 39.9305H17.5863C17.9291 39.9305 18.207 40.2084 18.207 40.5513C18.207 40.8941 17.9291 41.172 17.5862 41.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1055 30.6202H12.6207C12.2779 30.6202 12 30.3423 12 29.9995C12 29.6567 12.2779 29.3788 12.6207 29.3788H19.6594C19.7932 29.6556 19.999 29.8914 20.2552 30.0615L21.1055 30.6202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3808 18.8271L26.2821 20.0685H21.3104C20.9676 20.0685 20.6897 19.7906 20.6897 19.4477C20.6897 19.1049 20.9676 18.827 21.3104 18.827L27.3808 18.8271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8275 20.0685H16.9654C16.6227 20.0685 16.3447 19.7906 16.3447 19.4477C16.3447 19.1049 16.6226 18.827 16.9654 18.827H18.8275C19.1703 18.827 19.4483 19.1049 19.4483 19.4477C19.4483 19.7906 19.1703 20.0685 18.8275 20.0685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0725 22.5512L22.9677 23.7926H13.8622C13.5194 23.7926 13.2415 23.5147 13.2415 23.1719C13.2415 22.829 13.5193 22.5511 13.8622 22.5511H24.0725V22.5512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3165 25.6546L20.2117 26.896H18.8275C18.4847 26.896 18.2068 26.6181 18.2068 26.2753C18.2068 25.9324 18.4847 25.6545 18.8275 25.6545H21.3165V25.6546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3448 26.896H15.1034C14.7606 26.896 14.4827 26.6181 14.4827 26.2753C14.4827 25.9324 14.7605 25.6545 15.1034 25.6545H16.3448C16.6875 25.6545 16.9655 25.9324 16.9655 26.2753C16.9655 26.6181 16.6875 26.896 16.3448 26.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3882 36.2064L25.0903 37.4477H13.2413C12.8986 37.4477 12.6206 37.1699 12.6206 36.827C12.6206 36.4842 12.8985 36.2063 13.2413 36.2063H25.3882V36.2064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8475 34.2761L25.8288 34.3443H20.6896C20.3468 34.3443 20.0688 34.0665 20.0688 33.7236C20.0688 33.3808 20.3467 33.1029 20.6896 33.1029H24.8978L25.6178 33.5746C25.8235 33.7445 25.9129 34.0176 25.8475 34.2761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.207 34.3443H15.7242C15.3815 34.3443 15.1035 34.0665 15.1035 33.7236C15.1035 33.3808 15.3814 33.1029 15.7242 33.1029H18.207C18.5497 33.1029 18.8277 33.3808 18.8277 33.7236C18.8277 34.0665 18.5497 34.3443 18.207 34.3443Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_328_2168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalLoad);
export default __webpack_public_path__ + "static/media/totalLoad.3755347bc0ec5d4074f7eab0af645548.svg";
export { ForwardRef as ReactComponent };